import { Box } from "@bpba/ui-components";
import { useState } from "react";
import styled from "styled-components";
import { Form } from "../components/bloqueo-bip/Form";
import { Result } from "../components/bloqueo-bip/Result";

export const BloqueoBipBase = () => {
  const [state, setState] = useState<number>(1);
  const [result, setResult] = useState<[string, string]>(["", ""]);

  const renderFragment = () => {
    switch (state) {
      case 1:
        return <Form callback={showResult} />;
      case 2:
        return <Result callback={showForm} info={result} />;

      default:
        return <Form callback={showResult} />;
    }
  };

  const showForm = () => {
    setState(1);
  };

  const showResult = (info: [string, string]) => {
    setResult(info);
    setState(2);
  };

  return (
    <Box
      margin={["0px", "48px auto"]}
      backgroundColor={"white"}
      maxWidth={["500px"]}
      flexDirection={"column"}
      pb={"48px"}
    >
      <Box
        background={"linear-gradient(45deg, #279D2EFF, #25B4BDFF)"}
        justifyContent={"center"}
        alignItems={"center"}
        py={"16px"}
      >
        <Box height={["34px"]} width={"100%"}>
          <img
            height={"100%"}
            width={"100%"}
            alt="Banco de la Provincia de Buenos Aires"
            src="https://www.bancoprovincia.com.ar/CDN/Get/logo_mobile_bip"
          />
        </Box>
      </Box>
      <Box px={"16px"} flexDirection={"column"}>
        {renderFragment()}
      </Box>
    </Box>
  );
};

export const BloqueoBip = styled(BloqueoBipBase)({});
